'use client';
// TODO: Fix React 19 compiler lint errors. See https://react.dev/learn/react-compiler
/* eslint-disable react-hooks/refs */
import { useClientConfig } from '@providers/ClientConfigProvider';
import Anchor from '@ui/Anchor/Anchor';
import cn from '@utils/cn';
import Image from 'next/image';
import { useRef, useState } from 'react';
import { Template } from '../TemplatesModule';
import {
  getTemplateGenerateDesignUrl,
  getTemplateIFrameUrl,
  getTemplateImageRegenerateUrl,
  getTemplateImageUrl,
} from './urls';
type ImageIframeProps = {
  template: Template;
  className?: string;
  href?: string;
};

export default function ImageIframe({ template, className, href }: ImageIframeProps) {
  const config = useClientConfig();
  const { isAnimated } = template;

  const [isHovered, setIsHovered] = useState<boolean>(false);
  const [isIframeLoaded, setIsIframeLoaded] = useState<boolean>(false);
  const [timerCount, setTimerCount] = useState<NodeJS.Timeout>();
  const [numberOfRetries, setNumberOfRetries] = useState<number>(0);
  const [src, setSrc] = useState<string>(getTemplateImageUrl(template.hash, config.CDN_URL));
  const imageRef = useRef<HTMLImageElement>(null);

  function onMouseEnter() {
    if (!isAnimated) {
      return;
    }

    setTimerCount(
      setTimeout(() => {
        setIsHovered(true);
      }, 500),
    );
  }

  function onMouseLeave() {
    if (!isAnimated) {
      return;
    }

    setIsHovered(false);
    setIsIframeLoaded(false);
    clearTimeout(timerCount);
  }

  function onError() {
    if (numberOfRetries >= 10) {
      return;
    }

    if (!numberOfRetries) {
      setSrc(getTemplateImageRegenerateUrl(template.hash, config.RESIZE_URL));
      return setNumberOfRetries(numberOfRetries + 1);
    }

    setTimeout(() => {
      setSrc(getTemplateImageUrl(template.hash, config.CDN_URL));
      setNumberOfRetries(numberOfRetries + 1);
    }, 500);
  }

  function onLoad() {
    if (!isHovered) {
      return;
    }

    setIsIframeLoaded(true);
  }

  const linkHref = href ? href : getTemplateGenerateDesignUrl(template.hash, config.APP_URL);
  const iframeUrl = getTemplateIFrameUrl(template.hash, config);

  return (
    <Anchor
      className={cn('relative flex cursor-pointer items-center justify-center', className)}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      href={linkHref}
    >
      <div className="absolute h-full w-full"></div>
      <div className={cn({ hidden: isIframeLoaded })}>
        <Image
          ref={imageRef}
          src={src}
          width={template.width ?? 600}
          height={template.height ?? 600}
          alt={template.alt ?? ''}
          onError={onError}
          loading="lazy"
        />
      </div>
      {isHovered && isAnimated && (
        <iframe
          className={cn({ 'invisible absolute': !isIframeLoaded })}
          src={iframeUrl}
          width={imageRef.current?.clientWidth}
          height={imageRef.current?.clientHeight}
          loading="lazy"
          scrolling="no"
          onLoad={onLoad}
        />
      )}
    </Anchor>
  );
}
